export const PortugalFlag = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480" {...props}>
      <path fill="#f00" d="M256 0h384v480H256z" />
      <path fill="#060" d="M0 0h256v480H0z" />
      <g transform="translate(256 240)">
        <g fill="none" stroke="#ff0" strokeWidth="9">
          <circle r="68" />
          <ellipse rx="68" ry="26" />
          <path d="M-68 0h136M0-68v136" />
        </g>
        <path fill="#f00" d="M-40-48h80v54a40 46 0 0 1-40 44 40 46 0 0 1-40-44z" />
        <g fill="#ff0">
          <circle cx="-40" cy="-48" r="6" />
          <circle cx="0" cy="-48" r="6" />
          <circle cx="40" cy="-48" r="6" />
          <circle cx="-40" cy="0" r="6" />
          <circle cx="40" cy="0" r="6" />
          <circle cx="-26" cy="38" r="6" />
          <circle cx="26" cy="38" r="6" />
        </g>
        <path fill="#fff" d="M-25-33h50v38a25 30 0 0 1-25 29 25 30 0 0 1-25-29z" />
        <g fill="#039">
          <rect x="-5" y="-25" width="10" height="12" />
          <rect x="-5" y="-6" width="10" height="12" />
          <rect x="-5" y="13" width="10" height="12" />
          <rect x="-19" y="-6" width="10" height="12" />
          <rect x="9" y="-6" width="10" height="12" />
        </g>
      </g>
    </svg>
  );
};
